<template>
<div class="accordion">
    <div class="header" v-on:click="toggle">
            <strong class="subtitulo">{{titulo}}</strong>
            <v-chip x-small label outlined :color="porcentaje=='100.0%'?'green':'red'" class="style_porcentaje">
                <strong>{{porcentaje}}</strong>
            </v-chip>
       
        <i class="fa fa-angle-down header-icon" v-bind:class="{ rotate: show }"></i>
    </div>
    <transition name="accordion" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:before-leave="beforeLeave" v-on:leave="leave">
        <div class="body" v-show="show">
            <div class="body-inner">
                <slot></slot>
            </div>
        </div>
    </transition>
</div>
</template>

<script>
export default {
    name: 'accordion',
    props: {
        porcentaje: {
            type: String,
            default: "0 %",
        },
        titulo: {
            type: String,
            default: "",
        }
    },
    methods: {
        toggle: function () {
            this.show = !this.show;
        },
        beforeEnter: function (el) {
            el.style.height = '0';
        },
        enter: function (el) {
            el.style.height = el.scrollHeight + 'px';
        },
        beforeLeave: function (el) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave: function (el) {
            el.style.height = '0';
        }
    },
    data() {
        return {
            show: false
        };
    },
};
</script>

<style scoped>
.accordion {
    margin-left: 15px;
    max-width: 90%;
    margin-bottom: 0px;
    border-radius: 6px;

}

.accordion .header {
    height: 20px;
    margin-top:2px;
    line-height: 20px;
    padding: 0 10px 0 8px;
    position: relative;
    color: #fff;
    cursor: pointer;
    margin-left: 5px;
    background-color: #0E4D78;
    background: rgba(14,77,120, 0.5);
    font-size: small;
}

.accordion .header-icon {
    position: absolute;
    top: 5px;
    right: 8px;
    transform: rotate(0deg);
    transition-duration: 0.3s;
}

.accordion .body {
    /*   display: none; */
    overflow: hidden;
    transition: 150ms ease-out;
    background: rgba(30, 40, 58, 0.3);
    height: auto;
    margin-left: 10px;
}

.accordion .body-inner {
    padding: 2px;
    overflow-wrap: break-word;
    margin-left: 10px;
    background-color: transparent;
    /*   white-space: pre-wrap; */
}

.accordion .header-icon.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
}

.style_porcentaje {
    width: 70px;
    margin-left: 10px;
}
.subtitulo {
    font-size: 14px;
}
</style>
